import { useMutation, useQuery } from '@tanstack/react-query'
import { BackupRunsFilterParams, CreateBackupParams } from '@/types/backup'
import { fetchBackupRuns, fetchBackupRun, deleteBackupRun, bulkDeleteBackupRuns, triggerBackup } from '@/lib/api'
import { useBulkDeleteSuccessHandler } from './use-bulk-delete'

export const useBackupRuns = (params: BackupRunsFilterParams, options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: ['backups', params],
    queryFn: () => fetchBackupRuns(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: options?.enabled ?? true
  })

export const useBackupRun = (id: string) =>
  useQuery({
    queryKey: ['backup', id],
    queryFn: () => fetchBackupRun(id),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: !!id
  })

export const useDeleteBackupRun = () =>
  useMutation({
    mutationFn: (id: string) => deleteBackupRun(id),
    onSuccess: () => {}
  })

export const useBulkDeleteBackupRuns = () => {
  const handleBulkDeleteSuccess = useBulkDeleteSuccessHandler()

  return useMutation({
    mutationFn: (ids: string[]) => bulkDeleteBackupRuns({ ids }),
    onSuccess: response => handleBulkDeleteSuccess(response)
  })
}

export const useTriggerBackup = () =>
  useMutation({
    mutationFn: (params: CreateBackupParams) => triggerBackup(params),
    onSuccess: () => {}
  })
